export function fallbackOnUndefined(primary, secondary) {
    return primary !== undefined ? primary : secondary;
}



// WEBPACK FOOTER //
// ./utils/helpers.js